import styled from "styled-components";
import { MenuNav as MenuNavMobile } from "../../core/containers/Menu/Mobile/components/MenuNav";
import { getBackgroundColor } from "../_themes/helpers";
import { Wrapper as SettingsWindowsCloseButtonMobileWrapper } from "../SettingsWindowsCloseButtonMobile/components/Wrapper";

interface IWithOpen {
  open?: boolean;
}

export const SettingsWindowMobile = styled<IWithOpen, "div">("div")`
  position: relative;
  pointer-events: all;
  display: flex;
  min-height: 0;
  flex: 1 0;
  width: 100%;
  transition: opacity 100ms ease,
    z-index 0ms ease ${({ open }) => (open ? "0ms" : "100ms")};
  opacity: ${({ open }) => (open ? 1 : 0)};
  flex-direction: column;
  justify-content: flex-end;
  padding-top: 40px; /* swedish buttons reserved space */
  background-color: ${getBackgroundColor("settingsWindow")};

  @media (orientation: landscape) {
    min-height: 0;
    flex-direction: row;
    flex: 1 1 100%;
  }

  &:before {
    background-color: ${getBackgroundColor("settingsWindow")};
    position: fixed;
    content: "";
    bottom: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    top: 0;
  }

  @media (orientation: portrait) {
    ${MenuNavMobile} {
      order: 1;
    }

    ${SettingsWindowsCloseButtonMobileWrapper} {
      order: 2;
    }
  }
`;
